// extracted by mini-css-extract-plugin
export default {"pigeon-container":"PigeonList_pigeon-container__j2ZjQ","list-view-container":"PigeonList_list-view-container__b+KSo"};